import {
  Button,
  ButtonGroup,
  Modal,
  ModalButtons,
  Text,
} from "@eventsquare/uikit";
import {
  RiCheckLine,
  RiEmotionUnhappyLine,
  RiWalletLine,
} from "@remixicon/react";
import { StatusCode } from "@/ApiCalls";

interface ResultViewProps {
  walletResponse: { status: StatusCode };
  isVisible: boolean;
  error: string | null;
  onClear: () => void;
  onTryAgain: () => void;
}

const ResultView = ({
  walletResponse,
  isVisible,
  onClear,
  onTryAgain,
}: ResultViewProps) => {
  const getIcon = (status: StatusCode) => {
    switch (status) {
      case "200":
        return RiCheckLine;
      case "404":
        return RiEmotionUnhappyLine;
      case "500":
        return RiWalletLine;
    }
  };

  const getMessage = (status: StatusCode) => {
    switch (status) {
      case "200":
        return "Payment successful!";
      case "404":
        return "Wallet not found!";
      case "500":
        return "Insufficient funds!";
    }
  };

  return (
    <Modal
      isVisible={isVisible}
      icon={getIcon(walletResponse.status)}
      iconColor={walletResponse.status === "200" ? "success" : "error"}
    >
      <Text
        variant="h3"
        color={walletResponse.status === "200" ? "success" : "error"}
      >
        {getMessage(walletResponse.status)}
      </Text>
      <ButtonGroup>
        <ModalButtons>
          {walletResponse.status === "200" && (
            <Button block onClick={onClear}>
              Clear Cart
            </Button>
          )}
          {(walletResponse.status === "404" ||
            walletResponse.status === "500") && (
            <Button block onClick={onTryAgain}>
              Try Again
            </Button>
          )}
        </ModalButtons>
      </ButtonGroup>
    </Modal>
  );
};

export default ResultView;
